import React from 'react';
import { Section } from '../ui/Section';
import { Heart, Eye, Shield, Feather, Sparkles, Anchor } from 'lucide-react';
export function Benefits() {
  const benefits = [{
    icon: <Eye className="w-6 h-6" data-id="element-1" />,
    text: 'Entender de dónde vienen muchos de tus patrones.'
  }, {
    icon: <Feather className="w-6 h-6" data-id="element-2" />,
    text: 'Poner en palabras cosas que venís sintiendo hace tiempo.'
  }, {
    icon: <Shield className="w-6 h-6" data-id="element-3" />,
    text: 'Procesar emociones en un espacio seguro y privado.'
  }, {
    icon: <Heart className="w-6 h-6" data-id="element-4" />,
    text: 'Mirarte con más honestidad y menos autoengaño.'
  }, {
    icon: <Sparkles className="w-6 h-6" data-id="element-5" />,
    text: 'Soltar creencias, culpas y cargas que ya no te sirven.'
  }, {
    icon: <Anchor className="w-6 h-6" data-id="element-6" />,
    text: 'Sentirte más clara, más fuerte y más conectada con vos.'
  }];
  return <Section bgColor="cream" data-id="element-7">
      <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-8">
        <h2 className="text-3xl md:text-4xl font-serif mb-6" data-id="element-9">
          Lo que vas a lograr✨
        </h2>
        <p className="text-brand-light text-lg" data-id="element-10">
          <strong data-id="element-11">Viaje a tu Interior</strong> es un journal digital de
          autoconociemiento guiado, progresivo y profundo.{' '}
          <strong data-id="element-12">
            No es un diario vacío ni un cuaderno de frases lindas.
          </strong>
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-13">
        {benefits.map((benefit, idx) => <div key={idx} className="bg-white p-8 rounded-sm shadow-card hover:shadow-soft transition-shadow duration-300 flex flex-col items-center text-center group pt-[17px] pb-[17px]" data-id="element-14">
            <div className="w-14 h-14 rounded-full bg-brand-blush text-brand-violet flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-15">
              {benefit.icon}
            </div>
            <p className="text-brand-dark font-medium leading-relaxed" data-id="element-16">
              {benefit.text}
            </p>
          </div>)}
      </div>
    </Section>;
}